import { z } from "zod";

export const RouteGetCdtCategories_categoryId_Stores = "/cdt/categories/:categoryId/stores";

export const ParamsCdtCategoryStoresSchema = z.object({
  categoryId: z.coerce.number().int().positive(),
});

export const CdtCategoryStoreAssignmentSchema = z.object({
  storeId: z.number().int().positive(),
  storeCode: z.string(),
  storeName: z.string().nullable(),
  assignedTreeId: z.number().int().positive().nullable(),
  assignedTreeName: z.string().nullable(),
  effectiveTreeId: z.number().int().positive().nullable(),
  effectiveTreeName: z.string().nullable(),
  isDefaultFallback: z.boolean(),
  cluster: z.string().nullable(),
  region: z.string().nullable(),
  /** Distinct fixture sections the store has for this category; null when it has no fixtures. */
  bayCount: z.number().int().nonnegative().nullable(),
});

export const ResponseGetCdtCategoryStoresSchema = z.array(CdtCategoryStoreAssignmentSchema);

export type ParamsCdtCategoryStores = z.infer<typeof ParamsCdtCategoryStoresSchema>;
export type CdtCategoryStoreAssignment = z.infer<typeof CdtCategoryStoreAssignmentSchema>;
export type ResponseGetCdtCategoryStores = z.infer<typeof ResponseGetCdtCategoryStoresSchema>;
